import React from "react";
import { SectionCard, Pill } from "../Ui";
import { formatListDate } from "../../lib/purchaseListMeta";
import { PADDY_LAB_METRICS, formatPaddyLabMetric } from "../../lib/paddyLabConfig";
import { hasRole, isAdmin, useAuth } from "../../context/AuthContext";
import LabReportReceiptActions from "./LabReportReceiptActions";

export default function StackSampleLabRegister({ reports = [], testId = "stack-lab-register" }) {
  const { user } = useAuth();
  const canSeeVerdict = isAdmin(user) || hasRole(user, "manager");
  return (
    <SectionCard title={`Stack sample lab register (${reports.length})`} testId={testId}>
      <p className="text-xs text-muted-foreground mb-3">
        Sample intake reports — print or download PDF.
      </p>
      <div className="overflow-x-auto rounded-md border border-border">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-widest text-muted-foreground bg-muted/40">
              <th className="px-3 py-2.5">Date</th>
              <th className="px-3 py-2.5">Party</th>
              <th className="px-3 py-2.5">Intake</th>
              <th className="px-3 py-2.5">Sample</th>
              <th className="px-3 py-2.5">Moisture</th>
              {canSeeVerdict ? <th className="px-3 py-2.5">Review</th> : null}
              <th className="px-3 py-2.5 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((r) => (
              <tr key={r.id} className="border-t border-border hover:bg-muted/20">
                <td className="px-3 py-2.5 text-xs">{formatListDate(r.created_at) || "—"}</td>
                <td className="px-3 py-2.5 text-xs">{r.party_name || "—"}</td>
                <td className="px-3 py-2.5 text-xs font-mono">{r.intake_code || "—"}</td>
                <td className="px-3 py-2.5 text-xs font-mono">{r.sample_code || "—"}</td>
                <td className="px-3 py-2.5 text-xs tabular-nums">
                  {formatPaddyLabMetric(r, PADDY_LAB_METRICS[0])}
                </td>
                {canSeeVerdict ? (
                  <td className="px-3 py-2.5">
                    <Pill tone={r.needs_admin_review ? "warning" : "success"}>
                      {r.needs_admin_review ? "Needs admin review" : "Recorded"}
                    </Pill>
                  </td>
                ) : null}
                <td className="px-3 py-2.5">
                  <LabReportReceiptActions
                    reportId={r.id}
                    kind="stack"
                    label={r.sample_code || r.intake_code}
                  />
                </td>
              </tr>
            ))}
            {reports.length === 0 && (
              <tr>
                <td colSpan={canSeeVerdict ? 7 : 6} className="text-center py-10 text-muted-foreground">No stack sample lab reports yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </SectionCard>
  );
}
